import { useTranslation } from 'react-i18next';
import { Box, Select, MenuItem, FormControl, Typography } from '@mui/material';
import { Language, getAvailableLanguages } from '@/components/common/translateFunctions';
import { provideFlagIcon } from '@/components/common/IconProvider';
import './SettingsPopup.css';

export default function LanguageSelect() {
  const { i18n } = useTranslation();

  const availableLanguages: Language[] = getAvailableLanguages();
  const english = {
    code: 'en',
    name: 'EN',
    order: 0,
    original: 'English',
  };
  const selected = availableLanguages.find((l) => l.code === i18n.language) ?? english;

  async function languageChange(language: Language) {
    await i18n.changeLanguage(language.code);
    localStorage.setItem('language', language.code);
  }

  return (
    <FormControl fullWidth data-qa-element-id="language_selector">
      <Select
        className="settings-box"
        displayEmpty
        value={selected?.code ?? ''}
        MenuProps={{
          classes: { paper: 'language-dropdown' },
        }}
        renderValue={() => (
          <Box className="language-box">
            <img className="icon-left" src={provideFlagIcon(selected.code)} />
            <Typography data-qa-element-id="selected_language_label">
              {selected.original} ({selected.name})
            </Typography>
          </Box>
        )}
      >
        {availableLanguages.map((language) => (
          <MenuItem key={language.code} value={language.code} onClick={() => languageChange(language)}>
            <Box className="language-box">
              <img className="icon-left" src={provideFlagIcon(language.code)} />
              <Typography data-qa-element-id={`language_for_${language.name}`}>
                {language.original} ({language.name})
              </Typography>
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
